<div class="company-newsletter">
    <div class="container">
        <div class="row">
            <!-- section title -->
            <div class="col-md-12 my-md-5 mb-5 sec-title">
                <app-title-page [dataTitle]="dataTitle" [link]="'#newsletters-doc'"></app-title-page>
            </div>
            <!-- documents -->
            <div class="col-md-12 documents" id="newsletters-doc">
                <div class="lane-top">
                    <div class="row mt-5">
                        <!-- Company Newsletters -->
                        <div class="col-md-12">
                            <h3 class="f-subtit mb-3">{{ dataSection[0]?.title }}</h3>
                            <div class="desc text-justify" [innerHTML]="dataSection[0]?.content"></div>
                            <div class="statements mt-4" *ngIf="year">
                                <div class="row">
                                    <div class="col-lg-3 col-md-4 col-sm-7 col-10 mx-md-0 mx-auto">
                                        <h5 class="tit-f18b text-md-left text-center">{{ isLang?.selectYears }}</h5>
                                        <div class="select-ver2 mt-3">
                                            <ng-select2 [(ngModel)]="year"
                                                        [data]="dataYear" 
                                                        [placeholder]="isLang?.selectYears"
                                                        (valueChanged)="valueChanged($event)">
                                            </ng-select2>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-4" *ngIf="dataPerNewsletter">
                                    <app-widget-pdf [isActive]="isActivePdf" [dataWidgetPdf]="dataPerNewsletter"></app-widget-pdf>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</div>
